module.exports = __webpack_public_path__ + "img/main-logo.7c2094d7.png";